<template>
  <div
    @mouseenter="showPopover"
    @mouseleave="handleMouseLeave"
    :id="'product-card-' + targetFromId + '-' + product.id"
    class="product-card-grid product-card-wrapper" ref="productCard">
    <div v-if="product.is_new_arrival" class="new-badge">
      <img :src="newBadgeImage" alt="" />
      <span class="text-white">NEW</span>
    </div>
    <div class="description mt-auto">
      <div class="d-flex gap-8 align-items-start flex-wrap mb-2 hot-or-daily">
        <div v-if="product.is_hot" class="hot-product-badge mr-0 width-fit-content">
          <img :src="hotImage" alt="" />
          <small>Hot Product</small>
        </div>
        <div id="limitPurchaseLabel"
             v-if="product.is_purchase_limit"
             v-b-popover.hover.top="purchaseLimitTooltipText"
             class="limit-purchase-badge mr-0 width-fit-content">
          <small>${{ this.dailyPurchaseLimitAmount }} per day</small>
        </div>
        <div v-if="product.is_daily_deal_today" class="daily-deal-badge mr-0 width-fit-content">
          <small>Daily Deal ${{ currencyFormat(product.daily_deal_price) }} USD</small>
        </div>
        <div
          v-if="product.is_rare_find" class="rare-find-product-badge mr-0 width-fit-content">
          <small>RareFind</small>
        </div>
      </div>
    </div>
    <a :href="productUrl" class="image">
      <img
        @error="handleImageError"
        :src="baseImage"
        :class="{ 'image-placeholder': !hasBaseImage }"
        alt="product image"
      />
    </a>
    <div class="description mt-auto">
      <span v-if="product.is_rare_find"
            class="text-green d-flex justify-content-center">Serial #: {{ product.serial_number }}</span>
      <h4 class="d-flex gap-10" data-toggle="tooltip" data-placement="top" :title="product.name">
        <a :href="productUrl" class="prod-name">{{ product.name }}</a>
        <a v-if="isAdmin" :href="`/admin/products/${product.id}`" target="_blank">
          <Edit2Icon />
        </a>
      </h4>
    </div>
    <div class="details mb-4">
      <span>As low as</span>
      <div class="price">
        <strong :class="product.is_daily_deal_today ? 'text-decoration-line-through' : ''">${{
            product.is_daily_deal_today
              ? currencyFormat(product.price.formatted)
              : currencyFormat(product.selling_price.formatted)
          }}</strong>
        <span class="text-muted">
          <span>Each</span>
        </span>
        <div class="ml-auto d-inline-flex">
          <img v-b-popover.hover.top="{content:earnedPointText,customClass:'points-popover'}" :src="coinImage" alt="" />
          <span class="ml-1">{{ product.points }}</span>
        </div>
      </div>
      <div v-if="product.variety" class="variety">
        <span>Variety:</span>
        <span class="tag">{{ product.variety }}</span>
      </div>
    </div>
    <div class="bottom">
      <b-overlay :show="apiLoading" spinner-variant="primary" blur=".3" opacity=".75" rounded="sm">
        <div class="add-to-cart">
          <div class="number-picker" :id="'number-picker-' + product.id">
            <b-popover
              placement="bottom"
              @click="showPop = false"
              triggers=""
              :target="'number-picker-' + product.id"
              :show.sync="showPop"
            >
              <span class="text-danger"> We have {{ maxSellingQty }} item(s) only in this item </span></b-popover
            >
            <input
              v-integer-only
              type="text"
              :value="productQty"
              :min="1"
              :max="maxSellingQty"
              id="qty"
              class="form-control input-number input-quantity"
              @input="updateQuantity($event.target.value)"
              @keydown.up="updateQuantity(productQty + 1)"
              @keydown.down="updateQuantity(productQty - 1)"
            />
            <span class="btn-wrapper">
              <button
                type="button"
                @click="updateQuantity(productQty + 1)"
                class="btn btn-number btn-plus"
                :disabled="productQty >= maxSellingQty"
                data-type="plus"
              >
                +
              </button>
              <button
                type="button"
                :disabled="productQty >= maxSellingQty || productQty == 1"
                @click="updateQuantity(productQty - 1)"
                class="btn btn-number btn-minus text-danger"
                data-type="minus"
              >
                -
              </button>
            </span>
          </div>
          <button
            v-if="hasNoOption || product.is_out_of_stock"
            class="btn btn-primary btn-add-to-cart"
            :class="{ 'btn-loading': addingToCart, 'btn-pre-order': preOrder }"
            :disabled="product.is_out_of_stock || productQty == '' || productQty == 0 || giftProduct || variantProduct"
            @click="addToCart"
          >
            <span v-if="preOrder">PRE-ORDER</span>
            <span v-else>{{ $trans("storefront::product_card.add_to_cart") }}</span>
          </button>
        </div>
      </b-overlay>
      <div class="rating">
        <ProductRating :ratingPercent="product.rating_percent" />
        <button
          class="btn btn-wishlist p-0"
          :class="{ added: inWishlist }"
          :title="$trans('storefront::product_card.wishlist')"
          @click="syncWishlist"
        >
          <i class="la-heart" :class="inWishlist ? 'las' : 'lar'"></i>
        </button>
      </div>
    </div>
    <div v-show="false">{{ fields }}</div>
    <!--    <div v-if="fields.length > 1 && product.qd_enabled && product.quantity_discount_with_min_max_front.length"-->
    <!--         class="qd-details">-->
    <!--      <QD :product-info-page="false" :methods="fields" :price="product.price" :items="product.quantity_discount_with_min_max_front" />-->
    <!--    </div>-->
    <b-popover
      v-if="product.is_hot"
      :target="'product-card-' + targetFromId + '-' +  product.id"
      triggers="hover"
      placement="right"
      custom-class="scrollable-popover"
    >
      <div class="popover-content">
        <p class="custom-font-size" v-html="hotProductsDisclaimer"></p>
      </div>
    </b-popover>
  </div>
</template>

<script>
import ProductRating from "./ProductRating.vue"
import ProductCardMixin from "../mixins/ProductCardMixin"
import QD from "./QD"
import { currencyFormat } from "../functions"
import DefaultImageMixin from "@core/mixin/DefaultImageMixin"
import { Edit2Icon } from "vue-feather-icons"
import store from "../store"
import Vue from "vue"

export default {
  components: { QD, ProductRating, Edit2Icon },
  mixins: [ProductCardMixin, DefaultImageMixin],
  mounted() {
    this.payment_methods.forEach((paymentMethod) => {
      this.fields.push(
        {
          key: paymentMethod.vendors,
          label: paymentMethod.vendors,
          discount_percentage: paymentMethod.discount_percentage
        }
      )
    })
  },
  data() {
    return {
      popoverElement: null,
      isHovering: false, // Track hover state globally
      fields: [
        { key: "qty", label: "Quantity", type: "Range" }
      ],
      currencyFormat,
      targetFromId: ""
    }
  },
  props: ["product", "isAdmin", "dailyPurchaseLimitAmount", "hotProductsDisclaimer", "targetFromId", "payment_methods"],
  computed: {
    earnedPointText() {
      return `Buy this product and earn up to ${this.product.points} reward points`
    },
    cart() {
      return store.state.cart
    },
    purchaseLimitTooltipText() {
      return "There is a $" + this.dailyPurchaseLimitAmount + " USD per person, per day limit for any combination of items that are specifically marked with the red $" + this.dailyPurchaseLimitAmount + " USD per day tag. This limit does not apply to any banknotes that do not have this tag."
    },
    giftProduct() {
      return store.state.cart.gift_products.find(item => item.id == this.product.id) != undefined
    },
    variantProduct() {
      return this.product.is_variant_enabled
    }
  },
  methods: {
    showPopover() {
      this.hoverOnCard = true
      if (this.popoverElement) return

      const rect = this.$el.getBoundingClientRect()
      console.log("rect", rect)

      // Create a container for the popover
      this.popoverElement = document.createElement("div")
      this.popoverElement.className = "product-hover-popover"
      this.popoverElement.style.position = "absolute"
      this.popoverElement.style.top = `${rect.bottom + window.scrollY - 6}px`
      this.popoverElement.style.left = `${rect.left + window.scrollX}px`
      this.popoverElement.style.width = `${rect.width}px`
      this.popoverElement.style.zIndex = "9999"
      this.popoverElement.style.background = "#fff"
      this.popoverElement.style.borderLeft = "1.5px solid #cfcfcf"
      this.popoverElement.style.borderRight = "1.5px solid #cfcfcf"
      this.popoverElement.style.borderBottom = "1.5px solid #cfcfcf"
      // this.popoverElement.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
      this.popoverElement.style.padding = "10px"
      this.popoverElement.style.borderBottomLeftRadius = "6px"
      this.popoverElement.style.borderBottomRightRadius = "6px"

      // Append the container to the body
      document.body.appendChild(this.popoverElement);

      // Dynamically render the QD component
      const QDComponent = Vue.extend(QD);
      const instance = new QDComponent({
        propsData: {
          productInfoPage: false,
          methods: this.fields,
          price: this.product.price,
          items: this.product.quantity_discount_with_min_max_front,
        },
      });

      // Mount the QD component and append it to the popover container
      instance.$mount();
      this.popoverElement.appendChild(instance.$el);

      // Store the instance for cleanup
      this.popoverInstance = instance;

      // Add event listeners to the popover for hover handling
      this.popoverElement.addEventListener("mouseenter", this.handleMouseEnterPopover);
      this.popoverElement.addEventListener("mouseleave", this.handleMouseLeavePopover);
    },
    hidePopover() {
      if (!this.isHovering && this.popoverElement) {
        // Remove the dynamic component
        this.popoverInstance.$destroy();
        document.body.removeChild(this.popoverElement);
        this.popoverElement = null;
        this.popoverInstance = null;
      }
    },
    handleMouseLeave() {
      this.isHovering = false;
      setTimeout(() => this.hidePopover(), 100); // Add slight delay to allow hover transition
    },
    handleMouseEnterPopover() {
      this.isHovering = true; // Keep popover visible
    },
    handleMouseLeavePopover() {
      this.isHovering = false;
      setTimeout(() => this.hidePopover(), 100); // Add slight delay to handle smooth exit
    },
  },
  beforeDestroy() {
    if (this.popoverElement) {
      this.popoverInstance.$destroy()
      document.body.removeChild(this.popoverElement)
    }
  }
}
</script>

<style lang="scss">
.scrollable-popover .popover-content strong {
  font-weight: bold;
  color: inherit;
}

.scrollable-popover .popover-content {
  max-height: 500px;
  max-width: 800px;
  overflow-y: auto;
  overflow-x: hidden;
}

.btn-pre-order {
  background: #dc3545 !important;
}

.width-fit-content {
  width: fit-content;
}

.product-card-grid {
  display: flex !important;
  height: 100%;
  width: 100%;
  flex-direction: column;
  padding: 16px;
  border: 1.5px solid #cfcfcf;
  border-radius: 8px;
  position: relative;

  .new-badge {
    position: absolute;
    top: -2px;
    left: -2px;
    display: flex;

    span {
      position: absolute;
      transform: rotate(-45deg);
      top: 12px;
      left: 6px;
      font-size: 14px;
      font-weight: bold;
    }
  }

  .image {
    height: 250px;
    cursor: pointer;

    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  .description {
    padding-top: 8px;

    .hot-or-daily {
      height: 60px;

      .rare-find-product-badge,
      .limit-purchase-badge,
      .hot-product-badge,
      .daily-deal-badge {
        display: inline-flex;
        align-items: center;
        border-radius: 30px;
        padding: 4px 14px;
        gap: 5px;

        img {
          width: 16px;
        }

        small {
          color: #ffffff;
          font-size: 12px;
        }
      }

      .hot-product-badge {
        background: #ff5656;
      }

      .daily-deal-badge {
        background: #40c887;
      }

      .limit-purchase-badge {
        background: red;
      }

      .rare-find-product-badge {
        background: green;
      }
    }

    > h4 {
      .prod-name {
        display: -webkit-box;
        //height: 5.25rem;
        -webkit-line-clamp: 3; /* Limit the content to 3 lines */
        -webkit-box-orient: vertical;
        overflow: hidden;
        max-width: 100%;
        text-overflow: ellipsis;
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
      }
    }
  }

  h5 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 0;
    min-height: 48px;
  }

  .details {
    .price {
      display: flex;
      gap: 8px;
      align-items: center;
      font-size: 16px;

      strong {
        //font-size: 24px;
        color: #DEAA5E;
        font-weight: 700;
      }
    }

    .variety {
      display: flex;
      flex-wrap: wrap;
      gap: 7px;
      margin-bottom: 8px;

      .tag {
        padding: 0 12px;
        font-size: 12px;
        display: flex;
        align-items: center;
        font-weight: 600;
        background-color: #f3f3f3;
        border-radius: 30px;
      }
    }
  }

  .bottom {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .add-to-cart {
      display: flex;
      gap: 10px;

      .number-picker {
        display: inline-flex;
        align-items: center;
        position: relative;
        width: 48%;
        height: 40px;
      }

      .number-picker label {
        font-weight: 500;
        margin-bottom: 0;
      }

      .number-picker .input-quantity {
        padding: 10px 39px 10px 10px;
        height: 40px;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
      }

      .number-picker .input-quantity:focus {
        outline: 0;
        border-color: #ebebeb;
      }

      .number-picker .btn-wrapper {
        position: absolute;
        top: 0;
        right: 0;
      }

      .number-picker .btn-wrapper .btn-number {
        cursor: pointer;
        position: absolute;
        right: 0;
        width: 30px;
        padding: 0;
        line-height: 18px;
        background: none;
        border: 1px solid #ebebeb;
        border-radius: 0;
      }

      .number-picker .btn-wrapper .btn-number:hover {
        color: #DEAA5E;
      }

      .number-picker .btn-wrapper .btn-number[disabled]:hover {
        color: #191919;
      }

      .number-picker .btn-wrapper .btn-plus {
        top: 0;
        color: #DEAA5E;
        height: 20px;
        border-top-right-radius: 2px;
        border-bottom: 1px solid #ebebeb;
        border-left: 1px solid #ebebeb;
      }

      .number-picker .btn-wrapper .btn-minus {
        top: 20px;
        height: 20px;
        border-bottom-right-radius: 2px;
        border-left: 1px solid #ebebeb;
      }

      .btn-add-to-cart {
        padding: 10px;
        width: 48%;
        line-height: 20px;
        border-radius: 4px;
        font-size: 14px;
      }
    }

    .rating {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}

.text-muted {
  color: #b5b5b5 !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.slick-list.draggable {
  z-index: 1;
}

.qd-details {
  position: absolute;
  height: 0;
  border-left: 1px solid #cfcfcf;
  border-right: 1px solid #cfcfcf;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  top: calc(100% - 10px);
  background-color: #fff;
  z-index: 100;
  overflow: hidden;
  left: -1px;
  right: -1px;
}

.product-card-grid:hover .qd-details {
  height: fit-content;
  border-bottom: 1px solid #cfcfcf;
}

.text-green {
  color: green;
}

.points-popover {
  min-width: fit-content;
  width: 100%;
}
</style>
